import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vShow as _vShow, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7f488468"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_2 = {
  class: "content__container"
};
const _hoisted_3 = {
  class: "header"
};
const _hoisted_4 = ["onClick"];
import { useRoute, useRouter } from 'vue-router';
import TagType from '@/views/common/TagType/index.vue';
import { objToArr, transferTime, getItemByProp, treeIterator } from '@/utils/tools';
import Buttons from '@/components/Buttons/index.vue';
import EpgCheck from './epgCheck';
import Dialog from './dialog';
import dayjs from 'dayjs';
import { onMounted, nextTick } from 'vue';
import UploadFile from '@/views/liveChannel/components/uploadFile.vue';
import { getLiveChannelListApi, getLanguageListApi, getSysDictListApi, cleanCacheApi, getEnListApi, getCpspCategoriesApi, editReleaseStateApi, editCheckStateApi, exportChannelListApi, getChannelDetailApi } from '@/api/live';
import { useCommon } from '@/store/useCommon';
import { ProgramTypeObject } from '@/assets/config/dicts';
import { ElMessage } from 'element-plus';
import { getCurrentTime } from '@/utils/timeFormat';
import { liveStore } from '@/store/liveStore';
import { useI18n } from 'vue-i18n';
import BatchOperation from '@/views/liveChannel/components/batchOperation.vue';
import { getUserByCidApi } from '@/api/authority';
import { useBrandsByUser } from '@/utils/cacheData';
import CheckChannel from '@/views/liveChannel/components/checkChannel.vue';
import InfoDialog from '@/views/liveChannel/components/infoDialog.vue';
import XEUtils from 'xe-utils';
import { findLabel } from '@/utils/tools.ts'; // 表格列排序

const __default__ = {
  name: 'FilmReview'
};
export default /*#__PURE__*/_defineComponent({ ...__default__,

  setup(__props) {
    const {
      t
    } = useI18n();
    const route = useRoute();
    const router = useRouter();
    const isShowAside = ref(true);
    const isVnoAccount = useCommon().userData.roles.some(item => /VNO/ig.test(item)) || useCommon().userData.roles.includes('CUSTOMER_SN'); //区分是否为vno运营商账号

    const selectedNodes = ref([]); //tree组件选中的节点

    const tableRef = ref();
    const infoDialog = reactive({
      visible: false
    }); //运营商id vno账号下有一个id，否则就是根据下拉框来选  注意：后续端口用到cpspId时，如果不是vno账号要重新从sessionStorage获取

    const cpspId = isVnoAccount ? useCommon().userData.cid[0] : Number(sessionStorage.getItem('currentCid'));
    const enList = ref([]);
    const tableWarpRef = ref(null);
    const languageList = ref([]);
    const sysDictList = ref([{
      label: t('全部'),
      value: ''
    }]);
    const sortParams = reactive({
      orderBy: null,
      orderType: null
    });
    const loading = ref(true);
    const treeData = ref([]);
    const selectedChannelIdList = ref([]);
    const selectedChannel = ref([]);
    const tagRef = ref();
    const activeTag = ref(0); //激活的tag标签，默认0:全部 REVIEW_STATUS

    const operatorList = ref([]); //操作用户列表

    const tableContainer = ref(null);
    const activeList = ref([{
      label: t('全部'),
      value: ''
    }, {
      label: t('未激活'),
      value: 1
    }]);
    const transferProtocolObj = ref([{
      label: t('全部'),
      value: ''
    }]);
    const REVIEW_STATUS = {
      '0': '全部',
      '1': '未上线',
      '2': '已上线',
      '3': '已下线'
    };
    const ReviewStatus = {
      '0': t('未上线'),
      '1': t('已上线'),
      '2': t('已下线'),
      '4': t('退回审核')
    };

    const calculateColor = state => {
      let color = '';

      switch (state) {
        case 0:
          color = "orange";
          break;

        case 1:
          color = "rgb(62 213 150)";
          break;

        case 2:
          color = "red";
          break;
      }

      return color;
    };

    onMounted(() => {
      loading.value = true;
      sessionStorage.setItem('currentCid', cpspId);
      getSysDictList('code_protocol'); //getCpspCategories(cpspId)

      getBrands(); // closeAside()

      getLiveChannelList(1, 10, {
        cpspId
      });
    });
    const Tags = computed(() => {
      let common = objToArr(REVIEW_STATUS, 'type', 'name');
      return isShowAside.value ? common : [{
        type: 'close',
        name: '',
        noActive: true,
        icon: 'icon-ic_list'
      }, ...common];
    }); // 处理点击事件

    const handleTagClick = async tag => {
      // if(tag.type === 'close') return closeAside()
      activeTag.value = tag.type;
      const cid = isVnoAccount ? cpspId : sessionStorage.getItem('currentCid'); //运营商id

      if (activeTag.value == 0) {
        getLiveChannelList(1, 10, {
          cpspId: cid,
          ...searchParams,
          ...sortParams
        });
      } else {
        let releaseState = Number(activeTag.value) - 1;
        getLiveChannelList(1, 10, {
          cpspId: cid,
          releaseState,
          ...searchParams,
          ...sortParams
        });
      }
    };

    const searchConfig = reactive({
      size: {
        sm: 24,
        md: 12,
        lg: 8,
        xl: 6,
        xs: {}
      },
      formList: [{
        label: '品牌',
        prop: 'cid',
        widgetType: 'Select',
        valueKey: 'cid',
        labelKey: 'prefixName',
        list: [],
        disabled: isVnoAccount,
        change: val => {
          handleSearch({
            cid: val
          });
        }
      }, {
        label: '关键字筛选',
        prop: 'keyWord',
        widgetType: 'inputWithTooltip',
        placeholder: t('输入频道名称、节目识别号（原台标）、备注'),
        tooltip: true
      }, {
        label: '编码协议',
        prop: 'codeProtocol',
        widgetType: 'Select',
        list: sysDictList,
        valueKey: 'value'
      }, {
        label: '分类属性',
        prop: 'categoryProperty',
        widgetType: 'Select',
        multiple: true,
        collapseTags: true,
        list: enList,
        valueKey: 'label',
        visibleChange: async isVisible => {
          let nowItem = getItemByProp(searchConfig.formList, 'categoryProperty');

          if (isVisible && enList.value.length <= 1) {
            nowItem.loading = true;
            await getEnList();
            nowItem.loading = false;
          }
        }
      }, {
        label: '语言',
        prop: 'lang',
        widgetType: 'Select',
        multiple: true,
        collapseTags: true,
        list: languageList,
        valueKey: 'label',
        visibleChange: async isVisible => {
          let nowItem = getItemByProp(searchConfig.formList, 'lang');

          if (isVisible && languageList.value.length <= 1) {
            nowItem.loading = true;
            await getLanguageList();
            nowItem.loading = false;
          }
        }
      }, {
        label: '创建时间',
        prop: 'createTime',
        widgetType: 'date',
        type: 'daterange',
        valueFormat: 'x'
      }, {
        label: '操作用户',
        prop: 'operatingUser',
        widgetType: 'Select',
        placeholder: '请选择操作用户',
        labelKey: 'name',
        valueKey: 'id',
        list: [{
          name: t('全部'),
          id: ''
        }],
        visibleChange: async isVisible => {
          let nowItem = getItemByProp(searchConfig.formList, 'operatingUser');

          if (isVisible && operatorList.value.length <= 1) {
            nowItem.loading = true;

            try {
              await getUserByCid({
                cid: cpspId
              });
            } catch (error) {
              console.error('获取操作用户失败:', error);
            } finally {
              nowItem.loading = false;
            }
          }
        }
      }, {
        label: '激活状态',
        prop: 'physicalChannelState',
        widgetType: 'Select',
        list: activeList,
        valueKey: 'value'
      }, {
        label: '传输协议',
        prop: 'transferProtocol',
        widgetType: 'Select',
        list: transferProtocolObj,
        valueKey: 'value',
        visibleChange: async isVisible => {
          let nowItem = getItemByProp(searchConfig.formList, 'transferProtocol');

          if (isVisible && transferProtocolObj.value.length <= 1) {
            nowItem.loading = true;
            await getSysDictList('transfer_protocol');
            nowItem.loading = false;
          }
        }
      }, {
        label: ' 显示编号',
        prop: 'showNo',
        widgetType: 'input'
      }],
      formData: {
        cid: Number(cpspId),
        operatingUser: '',
        codeProtocol: '',
        physicalChannelState: '',
        transferProtocol: ''
      }
    });
    const tableConfig = reactive({
      data: [],
      isCardBlock: true,
      paginationConfig: {
        page: 1,
        limit: 10,
        total: 0
      },
      isShowHeader: false,
      headerButtonsList: [{
        label: '清除缓存',
        type: 'primary',
        controller: data => {
          const cpspId = isVnoAccount ? useCommon().userData.cid[0] : Number(sessionStorage.getItem('currentCid'));
          if (cpspId == 0) return true;
        },
        func: () => {
          let cid = Number(sessionStorage.getItem('currentCid'));
          cleanCacheApi(cid).then(res => {
            if (res.code == 0) {
              ElMessage({
                type: 'success',
                message: t('清除缓存成功')
              });
            }
          });
        }
      }, {
        label: 'EPG检查',
        permissionKey: 'LC_CM_EPG',
        type: 'purple',
        func: () => {
          if (selectedChannel.value.length === 0) return ElMessage({
            type: 'error',
            message: t('请选择至少一个频道')
          });
          let epgSatellite = selectedChannel.value.filter(item => item.satellite !== '').map(item => item.satellite).join(';');
          epgCheckObj.dialogVisible = true;
          epgCheckObj.row.Satellite = epgSatellite;
        }
      }, {
        label: '导出',
        permissionKey: 'LC_CM_OP',
        type: 'green',
        func: () => {
          let ids = selectedChannelIdList.value.toString();

          if (searchParams.categoryIds && searchParams.categoryIds.length !== 0) {
            // 按品牌导出，excel可分工作簿
            exportChannelList(searchParams.categoryIds.toString(), '');
          } else {
            // 正常按分类导出
            exportChannelList('', ids);
          }
        }
      }, {
        label: '导入频道状态',
        permissionKey: 'LC_CM_IP',
        func: () => {
          channelStateDialogObj.dialogVisible = true;
          channelStateDialogObj.cid = sessionStorage.getItem('currentCid');
        }
      }, {
        label: '批量操作',
        permissionKey: 'LC_CM_BT',
        type: 'yellow',
        func: () => {
          if (selectedChannel.value.length > 0) {
            const stateArr = selectedChannel.value.map(item => item.releaseState);
            const isSameState = Array.from(new Set(stateArr)).length === 1;

            if (isSameState) {
              liveStore().addSelectedChannel(JSON.parse(JSON.stringify(selectedChannel.value)));
              operationObj.visible = true;
              operationObj.mode = 'releaseState';
            } else {
              ElMessage({
                type: 'error',
                message: t('请勾选相同状态的频道')
              });
            }
          } else {
            return ElMessage({
              type: 'error',
              message: t('请选择至少一个频道')
            });
          }
        }
      }, {
        label: '',
        func: () => {},
        cellSlot: true
      }]
    });

    const filterColumnItemChange = () => {
      nextTick(() => {
        tableRef.value && tableRef.value.commonTableRef.doLayout();
      });
    };

    const columnConfig = reactive({
      columnList: [{
        label: '',
        prop: '',
        type: 'selection'
      }, {
        label: '序号',
        prop: 'no',
        align: 'left',
        width: 100
      }, {
        label: '频道名称',
        prop: 'name',
        align: 'left',
        width: 250,
        sortable: 'custom',
        'sort-orders': ['ascending', 'descending']
      }, {
        label: '节目识别号',
        prop: 'callSign',
        align: 'left',
        width: 150,
        sortable: 'custom',
        'sort-orders': ['ascending', 'descending']
      }, {
        label: ' 显示编号',
        prop: 'showNo',
        align: 'left',
        width: 150,
        sortable: 'custom',
        'sort-orders': ['ascending', 'descending']
      }, {
        label: '编码标准',
        prop: 'programType',
        align: 'left',
        width: 110,
        formatter: value => findLabel(ProgramTypeObject, value)
      }, {
        label: '字幕类型',
        prop: 'subtitle',
        align: 'left',
        width: 110,
        sortable: 'custom',
        'sort-orders': ['ascending', 'descending'],
        formatter: value => {
          if (value && value.length > 0) return Array.from(new Set(value.split(',').map(item => item.split('+')[0]))).join(',');
          return '--';
        }
      }, {
        label: '上线状态',
        prop: 'releaseState',
        align: 'left',
        formatter: value => ReviewStatus[value],
        cellSlot: true,
        slotName: 'stateColumn',
        width: 100
      }, {
        label: 'EPG标记',
        prop: 'satellite',
        align: 'left',
        width: 155
      }, {
        label: '操作用户',
        prop: 'operatorName',
        align: 'left',
        width: 160,
        sortable: 'custom',
        'sort-orders': ['ascending', 'descending'],
        formatter: value => {
          return value === null ? '/' : value;
        }
      }, {
        label: '创建时间',
        prop: 'createTime',
        align: 'left',
        width: 270,
        sortable: 'custom',
        'sort-orders': ['ascending', 'descending'],
        formatter: value => getCurrentTime(value)
      }, {
        label: '分类属性',
        prop: 'categoryProperty',
        width: 180,
        sortable: 'custom',
        'sort-orders': ['ascending', 'descending']
      }, {
        label: '关联信息',
        prop: 'info',
        width: 130,
        cellSlot: true,
        slotName: 'infoColumn'
      }, {
        label: '备注',
        prop: 'remark',
        align: 'left',
        width: 150
      }, {
        label: '操作',
        align: 'left',
        prop: '',
        fixed: 'right',
        width: 210,
        widgetType: 'buttons',
        // 审核状态state: 0:未审核,1:通过,2:未通过,3:终端审核,4:退回
        // 上线状态releaseState: 0：未上线，1：已上线，2：已下线 
        buttonsList: [{
          label: '查看',
          permissionKey: 'LC_CM_VW',
          func: data => {
            checkChannelObj.visible = true;
            checkChannelObj.detailInfo.id = data.id;
            checkChannelObj.detailInfo.releaseState = data.releaseState;
            checkChannelObj.detailInfo.offlineReason = data.offlineReason;
          }
        }, {
          label: '上线',
          permissionKey: 'LC_CM_ON',
          controller: data => {
            if (data.releaseState === 0 && data.state === 1 || data.releaseState === 2 && data.state === 1) {
              return true;
            }
          },
          func: data => {
            dialogObj.title = '上线';
            dialogObj.width = '25%';
            dialogObj.dialogVisible = true;
            dialogObj.row = data;
          }
        }, {
          label: '下线',
          permissionKey: 'LC_CM_OFF',
          controller: data => {
            if (data.releaseState === 1) {
              return true;
            }
          },
          func: data => {
            dialogObj.title = '下线';
            dialogObj.width = '30%';
            dialogObj.dialogVisible = true;
            dialogObj.row = data;
          }
        }, {
          label: '退回审核',
          permissionKey: 'LC_CM_BK',
          controller: data => {
            if (data.releaseState === 2) {
              return true;
            }
          },
          func: data => {
            dialogObj.title = '退回审核';
            dialogObj.width = '25%';
            dialogObj.dialogVisible = true;
            dialogObj.row = data;
          }
        }]
      }]
    });
    const tableWidth = ref('0px'); // 关闭侧边栏
    // const closeAside = () => {
    //   tagRef.value.activeType = activeTag.value.toString()
    //   isShowAside.value = !isShowAside.value
    //   if(isShowAside.value){
    //     // 侧边栏展开则把右边table容器的宽度设置成未展开时的宽度
    //     tableContainer.value.style.width = tableWidth.value + 'px'
    //   } else {
    //     //关闭侧边栏，记录展开时的宽度
    //      tableWidth.value = tableContainer.value.offsetWidth 
    //   }
    // }
    // 获取关联分类Tree

    const getCategoryTree = async id => {
      let targetTree = [];

      try {
        const {
          code,
          data
        } = await getChannelDetailApi(id);

        if (code == 0) {
          if (data.categoryPrograms && data.categoryPrograms.length > 0) {
            data.categoryPrograms.forEach(val => {
              // 根据详情返回的categoryId往treeData中找到目标的节点，结构为:[{label:a,children:{}},{label:a,children:{}}]
              let treeNode = XEUtils.searchTree(treeData.value, item => item.value == val.categoryId)[0];
              targetTree.push(treeNode);
            }); //最后合并相同的节点

            infoTreeData.value = treeIterator(targetTree);
          }
        } else {
          infoTreeData.value = [];
        }
      } catch (error) {
        console.error('获取频道详情失败:', error);
        infoTreeData.value = [];
      }
    };

    const infoTreeData = ref([]); //表格关联信息展示

    const onShowInfo = row => {
      infoTreeData.value = [];
      getCategoryTree(row.id);
      infoDialog.visible = true;
    }; // 分页size变化的回调


    const sizeChange = size => {
      loading.value = true;
      tableConfig.paginationConfig.limit = size;
      let params = {};
      const cid = isVnoAccount ? cpspId : sessionStorage.getItem('currentCid'); //运营商id

      if (activeTag.value == 0) {
        params = {
          cpspId: cid,
          ...searchParams,
          ...sortParams
        };
      } else {
        let releaseState = Number(activeTag.value) - 1;
        params = {
          cpspId: cid,
          releaseState,
          ...searchParams,
          ...sortParams
        };
      }

      getLiveChannelList(tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit, params);
    }; // 页码变化的回调


    const currentChange = page => {
      loading.value = true;
      tableConfig.paginationConfig.page = page;
      let params = {};
      const cid = isVnoAccount ? cpspId : sessionStorage.getItem('currentCid'); //运营商id

      if (activeTag.value == 0) {
        params = {
          cpspId: cid,
          ...searchParams,
          ...sortParams
        };
      } else {
        let releaseState = Number(activeTag.value) - 1;
        params = {
          cpspId: cid,
          releaseState,
          ...searchParams,
          ...sortParams
        };
      }

      getLiveChannelList(tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit, params);
    }; // 导出列表


    const exportChannelList = async (categoryId, ids) => {
      const cid = isVnoAccount ? cpspId : sessionStorage.getItem('currentCid'); //运营商id

      let params = {
        state: 1,
        beginTime: searchParams.beginTime,
        categoryProperty: searchParams.categoryProperty,
        endTime: searchParams.endTime,
        keyword: searchParams.keyword,
        language: searchParams.language,
        operator: searchParams.operator,
        programType: searchParams.programType
      };
      loading.value = true;

      try {
        await exportChannelListApi(categoryId, ids, cid, params).then(res => {
          const blob = new Blob([res], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          const objectUrl = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = objectUrl; // 设置文件名

          a.download = `CHANNEL_${dayjs(new Date()).format('YYYY-MM-DD')}`;
          a.click();
          a.remove();
          window.URL.revokeObjectURL(objectUrl);
          loading.value = false;
        });
      } catch (error) {
        console.error('导出频道列表失败:', error);
        loading.value = false;
      }
    };

    const epgCheckObj = reactive({
      dialogVisible: false,
      title: 'EPG检查',
      width: '85%',
      successBtnText: '确定',
      closeBtnText: '取消',
      isFooter: true,
      row: {
        Satellite: '0'
      }
    }); // 关闭弹框

    const cancelEpgCheck = () => {
      epgCheckObj.dialogVisible = false;
    }; //点击复选框的回调


    const handleSelectChange = row => {
      selectedChannelIdList.value = [];
      selectedChannel.value = [];

      if (row.length > 0) {
        row.forEach(val => {
          selectedChannelIdList.value.push(val.id);
          selectedChannel.value.push(val);
        });
      }
    }; // 上线/下线/退回审核的回调


    const dialogObj = reactive({
      dialogVisible: false,
      title: '',
      width: '30%',
      successBtnText: '确定',
      closeBtnText: '取消',
      isFooter: true,
      row: {}
    });

    const onCloseDialog = () => {
      dialogObj.dialogVisible = false;
    };

    const onDialogSubmit = async (data, state, backToCheck, offlineReason) => {
      // state: 1:上线 2：下线 4：退回
      // backToCheck:Boolean 直接退回审核，仅在下线时为true
      dialogObj.dialogVisible = false;
      let channelId = data.id;
      let params = {};

      if ([1, 2].includes(state)) {
        // 修改上下线状态
        try {
          // const {code, data} = await editReleaseStateApi(channelId, state) as any
          // if(code=='0'){
          //   handleTagClick({type:activeTag.value}) //查询当前激活的tag下的频道列表
          // }
          params.channelIds = data.id;
          params.state = state;
          if (state === 2) params.offlineReason = offlineReason; // 修改上下线状态

          await editReleaseStateApi(params).then(res => {
            handleTagClick({
              type: activeTag.value
            }); //查询当前激活的tag下的频道列表

            ElMessage({
              type: 'success',
              message: t(`${state === 1 ? '上线' : '下线'}成功`)
            });
          }).catch(err => {
            console.log('471err', err);
          });

          if (backToCheck) {
            await editCheckStateApi({
              channelIds: channelId,
              state: 4
            }).then(res => {
              ElMessage({
                type: 'success',
                message: t('退回审核成功')
              });
            }).catch(err => {
              console.log('477err', err);
            });
          }
        } catch (error) {
          console.error('修改上下线状态失败:', error);
        }
      } else {
        // 修改审核状态
        try {
          const {
            code,
            data
          } = await editCheckStateApi({
            channelIds: channelId,
            state
          });

          if (code === '0') {
            handleTagClick({
              type: activeTag.value
            });
          }
        } catch (error) {
          console.error('修改审核状态失败:', error);
        }
      }

      try {
        await getLiveChannelList(1, 10, {
          cpspId
        }); // 重新拉取列表
      } catch (error) {
        console.error('重新拉取列表失败:', error);
      }
    }; // 获取品牌选项数据


    const getBrands = async () => {
      const brands = await useBrandsByUser();
      let searchItem = getItemByProp(searchConfig.formList, 'cid');
      if (searchItem) searchItem.list = brands;
      const cid = sessionStorage.getItem('currentCid');

      if (!cid) {
        sessionStorage.setItem('currentCid', brands[0].cid);
      }
    }; // 获取操作用户


    const getUserByCid = async params => {
      try {
        const res = await getUserByCidApi(params);

        if (res.code == '0') {
          let item = getItemByProp(searchConfig.formList, 'operatingUser');
          item.list = [{
            name: t('全部'),
            id: ''
          }, ...res.data];
          operatorList.value = [...res.data];
        }
      } catch (error) {
        console.error('获取操作用户失败:', error);
      }
    }; // 获取分类属性列表


    const getEnList = async () => {
      try {
        const {
          code,
          data
        } = await getEnListApi(cpspId);

        if (code === '0') {
          enList.value = data;
        }
      } catch (error) {
        console.error('获取分类属性列表失败:', error);
      }
    }; // 获取语言列表


    const getLanguageList = async () => {
      try {
        const {
          code,
          data
        } = await getLanguageListApi();

        if (code === '0') {
          languageList.value = [...data];
        }
      } catch (error) {
        console.error('获取语言列表失败:', error);
      }
    }; // 获取编码协议列表


    const getSysDictList = async type => {
      try {
        const {
          code,
          data
        } = await getSysDictListApi(type);

        if (code === '0') {
          if (type === 'code_protocol') {
            sysDictList.value = [...sysDictList.value, ...data];
          } else {
            // 传输协议只设置一次，避免重复添加
            transferProtocolObj.value = [{
              value: '',
              label: t('全部')
            }, ...data].filter(item => item.value !== 4);
          }
        }
      } catch (error) {
        console.error('获取编码协议列表失败:', error);
      }
    }; // 获取直播频道列表


    const getLiveChannelList = async (pageNo = 1, pageSize = 10, params = {}) => {
      loading.value = true;
      let approvalChannelParams = {
        state: 1,
        ...params
      }; // 频道管理仅对审核通过的频道进行操作

      try {
        const {
          code,
          data
        } = await getLiveChannelListApi(pageNo, pageSize, approvalChannelParams);

        if (code === '0') {
          tableConfig.data = data.records.map((item, index) => {
            return { ...item,
              no: (pageNo - 1) * pageSize + index + 1 // 序号

            };
          });
          tableConfig.paginationConfig.page = data.current;
          tableConfig.paginationConfig.total = data.total;
          tableConfig.paginationConfig.limit = data.size;
          loading.value = false;
        } else {
          loading.value = false;
        }
      } catch (error) {
        console.error('获取直播频道列表失败:', error);
        loading.value = false;
      }
    };

    const getCpspCategories = async (id, keyword = '', codeProtocol = '') => {
      let params = {
        cid: id
      };

      if (keyword !== '') {
        params.keyword = keyword;
      }

      if (codeProtocol !== '') {
        params.codeProtocol = Number(codeProtocol);
      }

      try {
        const {
          code,
          data
        } = await getCpspCategoriesApi(params);

        if (code === '0') {
          data !== null && data.forEach(item => item.value = 'key' + item.cpspId); // 不执行这段，重置的时候会有bug

          treeData.value = data;
          console.log('treedata', treeData);
        }
      } catch (error) {
        console.error('获取分类列表失败:', error);
      }
    };

    let searchParams = reactive({
      categoryIds: [],
      cpspId
    });
    const defaultProps = reactive({
      children: 'children',
      label: 'label'
    });

    const handleCheck = (data, {
      checkedNodes,
      checkedKeys,
      halfCheckedNodes,
      halfCheckedKeys
    }) => {
      //console.log('data',data)
      console.log('node', checkedNodes);
      selectedNodes.value = checkedNodes; // data:object 勾选的节点数据 
      // checkedNodes:[{}] 勾选节点的数据，单独勾选子节点的时候元素内不会有children属性，出现children属性即有父节点被选中  
      // checkedKeys:[number] 已勾选的节点node-key
      // halfCheckedNodes:array 半勾选的节点数据，一般是父节点的数据
      // halfCheckedKeys:array  半勾选的节点node-key，一般是父节点的key

      const hasParentNode = halfCheckedKeys.length !== 0;
      const cid = isVnoAccount ? cpspId : sessionStorage.getItem('currentCid'); //运营商id

      searchParams.cpspId = cid;
      searchParams.categoryIds = []; // 上下线状态参数

      let releaseState = activeTag.value == 0 ? undefined : Number(activeTag.value) - 1;
      if (checkedNodes.length === 0) return getLiveChannelList(1, 10, { ...searchParams,
        releaseState
      }); //无选中节点
      // 过滤出子节点，也就是不含childred字段的节点数据

      let filterNodes = checkedNodes.filter(node => node.children === null || node.children.length === 0);

      if (hasParentNode) {
        // 点击子节点的情况： 1.仅点击子节点，不存在父节点选中 2.父节点选中，选中另外的子节点
        let parentArr = [];
        checkedNodes.forEach(item => {
          if (item.children && item.children.length > 0) {
            parentArr.push(item);
          }
        });

        if (parentArr.length > 0) {
          // 情况2
          filterNodes.forEach(item => searchParams.categoryIds.push(item.value));
        } else {
          // 情况1
          checkedNodes.forEach(item => {
            searchParams.categoryIds.push(item.value);
          });
        }
      } else {
        // 仅点击父节点的情况
        filterNodes.forEach(item => searchParams.categoryIds.push(item.value));
      } // 调接口查询列表


      getLiveChannelList(1, 10, { ...searchParams,
        ...sortParams,
        releaseState
      });
    };

    const handleSearch = formData => {
      console.log('search', formData);
      sessionStorage.setItem('currentCid', searchConfig.formData.cid.toString()); // 只有点击查询才能变更currentCid

      if (formData.keyWord && formData.keyWord.length > 255) return ElMessage({
        type: 'error',
        message: t('关键字的长度应在1到255字符之间')
      }); // 整理数据

      for (let key in formData) {
        switch (key) {
          case 'categoryProperty':
            if (formData[key].length === 0) {
              searchParams.categoryProperty = '';
            } else {
              searchParams.categoryProperty = formData[key].includes(t('全部')) ? '' : formData[key].toString();
            }

            break;

          case 'codeProtocol':
            searchParams.programType = formData[key];
            break;

          case 'createTime':
            searchParams.beginTime = transferTime(formData[key][0]);
            searchParams.endTime = transferTime(formData[key][1]);
            break;

          case 'keyWord':
            searchParams.keyword = formData[key];
            break;

          case 'lang':
            if (formData[key].length === 0) {
              searchParams.language = '';
            } else {
              searchParams.language = formData[key].includes(t('全部')) ? '' : formData[key].toString();
            }

            break;

          case 'operatingUser':
            searchParams.operator = formData[key];
            break;

          case 'physicalChannelState':
            searchParams.physicalChannelState = formData[key];
            break;

          case 'transferProtocol':
            searchParams.transferProtocol = formData[key];
            break;

          case 'showNo':
            searchParams.showNo = formData[key];
            break;
        }
      }

      console.log('searchParams', searchParams); // 整理searchParams

      for (let key in searchParams) {
        if (searchParams[key] === '' || searchParams[key].length === 0) {
          delete searchParams[key];
        }
      } // 区分当前点击的tag是否为全部


      const cid = isVnoAccount ? cpspId : sessionStorage.getItem('currentCid'); //运营商id

      searchParams.cpspId = cid;

      if (activeTag.value == 0) {
        getLiveChannelList(1, tableConfig.paginationConfig.limit, { ...searchParams,
          ...sortParams
        });
      } else {
        let releaseState = Number(activeTag.value) - 1;
        getLiveChannelList(1, tableConfig.paginationConfig.limit, {
          releaseState,
          ...searchParams,
          ...sortParams
        });
      } // if(!isVnoAccount){
      //   // 不是运营商的账号需要重新获取分类列表
      //   const cid = sessionStorage.getItem('currentCid') //运营商id
      //   getCpspCategories(cid, '', searchParams.programType)
      // }

    };

    const treeRef = ref(); // 重置按钮的回调

    const handleReset = () => {
      tableConfig.data = [];
      searchParams = reactive({
        categoryIds: [],
        cpspId
      });
      sortParams.orderBy = null;
      sortParams.orderType = null;
      tableRef.value.commonTableRef.clearSort(); //清空排序条件

      searchConfig.formData = {
        cid: isVnoAccount ? cpspId : 0,
        operatingUser: '',
        codeProtocol: '',
        physicalChannelState: '',
        transferProtocol: ''
      }; // 重置懒加载的字段列表

      enList.value = [];
      languageList.value = [];
      operatorList.value = [];
      transferProtocolObj.value = null;

      if (!isVnoAccount) {
        sessionStorage.setItem('currentCid', '0'); // 将sessionStorage重置为0，下次刷新时保证品牌默认选中的为0
      } //treeRef.value.setCheckedKeys([], false) //重置树形组件未未选中状态


      tagRef.value.onTagClick({
        name: '全部',
        type: '0'
      }); //重置tag激活全部选项
      // let id = isVnoAccount?cpspId:0 
      // getCpspCategories(id)
    }; // 导入频道状态


    const channelStateDialogObj = reactive({
      dialogVisible: false,
      title: '导入频道状态',
      width: '25%',
      successBtnText: '确定导入',
      closeBtnText: '取消',
      isFooter: true,
      uploadMode: 2,
      cid: cpspId //  当前品牌|选中的品牌的cpspId

    });

    const handleCloseDialog = isUploadFail => {
      channelStateDialogObj.dialogVisible = false;

      if (isUploadFail) {
        ElMessage({
          type: 'error',
          message: 'upload fail'
        });
      }
    };

    const handleDialogSubmit = isUploadSuccess => {
      channelStateDialogObj.dialogVisible = false;

      if (isUploadSuccess) {
        getLiveChannelList(1, 10, {
          cpspId
        });
      }
    }; // 批量操作


    const operationObj = reactive({
      visible: false,
      mode: 'releaseState'
    });

    const onUpdateList = () => {
      handleTagClick({
        type: activeTag.value.toString()
      }); // 请求对应tag的列表数据

      nextTick(() => {
        tagRef.value.activeType = activeTag.value.toString();
      });
    };

    const onCancel = () => {
      selectedChannel.value = [];
      nextTick(() => {
        tagRef.value.activeType = activeTag.value.toString(); //激活对应的tag标签

        handleTagClick({
          type: activeTag.value.toString()
        }); // 请求对应tag的列表数据
      });
    }; // 查看审核


    const checkChannelObj = reactive({
      visible: false,
      mode: 'detail',
      detailInfo: {
        title: '频道管理',
        id: 0,
        releaseState: 0,
        offlineReason: ''
      }
    }); // watch(() => tableConfig.data, (val) => {
    //   const columntree = document.querySelector('#columntree') as HTMLElement
    //   nextTick(() => {
    //     columntree.style.maxHeight = tableWarpRef.value.offsetHeight + 'px'
    //   })
    // })
    // 监听审核频道visible的变化，隐藏显示频道模块，tag标签激活为上次点击的

    watch(() => checkChannelObj.visible, newVal => {
      if (!newVal) return nextTick(() => {
        tagRef.value.activeType = activeTag.value.toString();
      });
    }); // 审核页面的显示与隐藏

    const mainPageVisible = computed(() => {
      if (!operationObj.visible && !checkChannelObj.visible) {
        return true;
      } else {
        return false;
      }
    }); // 监听主页的显示，设置tree组件节点选中状态

    watch(() => mainPageVisible.value, newVal => {
      if (newVal) {
        nextTick(() => {
          //将左侧el-tree勾选状态还原
          selectedNodes.value.forEach(item => {
            treeRef.value.setChecked(item.value, true, false);
          });
        });
      }
    }, {
      immediate: true,
      deep: true
    });

    const handleSortChange = sortType => {
      sortParams.orderBy = sortType.prop ? sortType.prop : undefined;

      if (sortType.order) {
        sortParams.orderType = sortType.order === 'ascending' ? 'ASC' : 'DESC';
      } else {
        sortParams.orderType = undefined;
      }

      let params = {};
      const cid = isVnoAccount ? cpspId : sessionStorage.getItem('currentCid'); //运营商id

      if (activeTag.value == 0) {
        params = {
          cpspId: cid,
          ...searchParams,
          ...sortParams
        };
      } else {
        let releaseState = Number(activeTag.value) - 1;
        params = {
          cpspId: cid,
          releaseState,
          ...searchParams,
          ...sortParams
        };
      }

      getLiveChannelList(tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit, params);
    };

    return (_ctx, _cache) => {
      const _component_search_form = _resolveComponent("search-form");

      const _component_TableColumnOptionBtn = _resolveComponent("TableColumnOptionBtn");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _directive_crosswiseScroll = _resolveDirective("crosswiseScroll");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_search_form, {
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        size: searchConfig.size,
        gutter: 30,
        onSearch: handleSearch,
        onReset: handleReset
      }, null, 8, ["form-list", "form-data", "size"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: "table__container",
        ref_key: "tableContainer",
        ref: tableContainer
      }, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(TagType, {
        modelValue: _unref(Tags),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(Tags) ? Tags.value = $event : null),
        onOnTagClick: handleTagClick,
        ref_key: "tagRef",
        ref: tagRef
      }, null, 8, ["modelValue"]), _createVNode(Buttons, {
        class: "header__btns",
        "buttons-list": tableConfig.headerButtonsList
      }, {
        cellSlot: _withCtx(scope => [_createVNode(_component_TableColumnOptionBtn, {
          "column-list": columnConfig.columnList,
          onFilterColumnItemChange: filterColumnItemChange
        }, null, 8, ["column-list"])]),
        _: 1
      }, 8, ["buttons-list"])])), [[_directive_crosswiseScroll]]), _createElementVNode("div", {
        class: "table-list",
        ref_key: "tableWarpRef",
        ref: tableWarpRef
      }, [_createVNode(_component_common_table, {
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        "pagination-config": tableConfig.paginationConfig,
        ref_key: "tableRef",
        ref: tableRef,
        onSizeChange: sizeChange,
        onCurrentChange: currentChange,
        onSelectionChange: handleSelectChange,
        onSortChange: handleSortChange
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": columnConfig.columnList
        }, {
          stateColumn: _withCtx(scope => [_createElementVNode("span", {
            style: _normalizeStyle({
              'color': calculateColor(scope.row.releaseState)
            })
          }, _toDisplayString(ReviewStatus[scope.row.releaseState]), 5)]),
          infoColumn: _withCtx(scope => [_createElementVNode("span", {
            class: "link",
            onClick: $event => onShowInfo(scope.row)
          }, _toDisplayString(_ctx.$t('信息')), 9, _hoisted_4)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config", "pagination-config"])], 512)], 512)])])), [[_directive_loading, loading.value], [_vShow, _unref(mainPageVisible)]]), epgCheckObj.dialogVisible ? (_openBlock(), _createBlock(_unref(EpgCheck), {
        key: 0,
        "dialog-object": epgCheckObj,
        onDialogClose: cancelEpgCheck,
        onDialogSuccess: cancelEpgCheck
      }, null, 8, ["dialog-object"])) : _createCommentVNode("", true), dialogObj.dialogVisible ? (_openBlock(), _createBlock(_unref(Dialog), {
        key: 1,
        "dialog-object": dialogObj,
        onDialogClose: onCloseDialog,
        onDialogSuccess: onDialogSubmit
      }, null, 8, ["dialog-object"])) : _createCommentVNode("", true), channelStateDialogObj.dialogVisible ? (_openBlock(), _createBlock(UploadFile, {
        key: 2,
        "dialog-object": channelStateDialogObj,
        onDialogClose: handleCloseDialog,
        onDialogSuccess: handleDialogSubmit
      }, null, 8, ["dialog-object"])) : _createCommentVNode("", true), _createVNode(BatchOperation, {
        modelValue: operationObj.visible,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => operationObj.visible = $event),
        mode: operationObj.mode,
        onUpdateList: onUpdateList,
        onCancel: onCancel
      }, null, 8, ["modelValue", "mode"]), _createVNode(CheckChannel, {
        modelValue: checkChannelObj.visible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => checkChannelObj.visible = $event),
        mode: checkChannelObj.mode,
        "detail-info": checkChannelObj.detailInfo,
        onUpdateList: onUpdateList
      }, null, 8, ["modelValue", "mode", "detail-info"]), _createVNode(InfoDialog, {
        modelValue: infoDialog.visible,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => infoDialog.visible = $event),
        "info-tree-data": infoTreeData.value
      }, null, 8, ["modelValue", "info-tree-data"])], 64);
    };
  }

});